import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M26.0486 12.3347C26.4949 11.8884 27.2185 11.8884 27.6648 12.3347C28.1111 12.7811 28.1111 13.5046 27.6648 13.951L21.616 19.9998L27.6648 26.0486C28.1111 26.4949 28.1111 27.2185 27.6648 27.6648C27.2185 28.1111 26.4949 28.1111 26.0486 27.6648L19.9998 21.616L13.951 27.6648C13.5046 28.1111 12.7811 28.1111 12.3347 27.6648C11.8884 27.2185 11.8884 26.4949 12.3347 26.0486L18.3836 19.9998L12.3347 13.951C11.8884 13.5046 11.8884 12.7811 12.3347 12.3347C12.7811 11.8884 13.5046 11.8884 13.951 12.3347L19.9998 18.3836L26.0486 12.3347Z",
		fill: "#C8C8C8"
	})]
});
export default SvgCloseDisabled;
